import React from "react";
import NavBar from "../component/NavBar";
import Footer from "../component/Footer";
import Partner from "../component/Partner";
import Phone from "../component/Phone";
import {
  adhd,
  Carousel2,
  anxiety,
  Bipolardisorder,
  services,
  adhd1,
} from "../assets";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";

const CarouselItems = [
  {
    src: Carousel2,
    alt: "Depression Treatment",
    title: "Depression",
    description: "Comprehensive care for understanding and managing depression symptoms.",
    link: "/depression",
  },
  {
    src: anxiety,
    alt: "Anxiety Treatment",
    title: "Anxiety",
    description: "Evidence-based strategies to manage worry and build resilience.",
    link: "/anxiety",
  },
  {
    src: adhd,
    alt: "ADHD Treatment",
    title: "ADHD",
    description: "Specialized treatment for attention and hyperactivity challenges.",
    link: "/adhd",
  },
  {
    src: Bipolardisorder,
    alt: "Bipolar Disorder Treatment",
    title: "Bipolar Disorder",
    description: "Medication and therapy to stabilize mood fluctuations.",
    link: "/bipolardisorder",
  },
];

const servicesList = [
  "Anxiety Disorders",
  "Depression",
  "Attention Deficit/Hyperactivity Disorder (ADHD)",
  "Bipolar Disorder",
  "Panic Disorder & Panic Attacks",
  "Geriatric Behavioral Health",
  "Obsessive Compulsive Disorder (OCD)",
  "Sleep Disorders",
  "Substance Abuse (Suboxone Treatment)",
  "Dual Diagnosis",
  "Trauma & PTSD",
  "Postpartum Depression",
  "Psychosis & Related Conditions",
];

const CarouselCard = ({ src, alt, title, description, link }) => (
  <div className="group bg-white rounded-xl overflow-hidden shadow-soft hover:shadow-medium transition-all duration-300 h-full flex flex-col">
    <div className="relative overflow-hidden h-56">
      <img
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        src={src}
        alt={alt}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 p-6">
        <h3 className="text-heading-md text-white font-semibold mb-2">{title}</h3>
      </div>
    </div>
    <div className="p-6 flex-1 flex flex-col">
      <p className="text-body-md text-neutral-600 mb-5 leading-relaxed flex-1">
        {description}
      </p>
      <Link to={link}>
        <button className="flex items-center gap-2 text-primary-600 font-semibold hover:text-primary-700 transition-colors group/btn">
          Learn More
          <FontAwesomeIcon icon={faArrowRight} className="text-sm group-hover/btn:translate-x-1 transition-transform" />
        </button>
      </Link>
    </div>
  </div>
);

const MainServicePage = () => {
  return (
    <div className="bg-white">
      <NavBar />
      <Phone />

      <div className="relative h-[400px] md:h-[500px] lg:h-[600px]">
        <img
          className="w-full h-full object-cover object-top"
          src={services}
          alt="Mental health services"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
        <div className="absolute inset-0 flex items-center justify-center px-6">
          <div className="text-center animate-fade-in">
            <h1 className="text-display-sm md:text-display-md lg:text-display-lg text-white font-bold mb-4">
              Our Services
            </h1>
            <p className="text-body-lg md:text-heading-sm text-white/90 max-w-2xl mx-auto">
              Comprehensive psychiatric care tailored to your unique needs
            </p>
          </div>
        </div>
      </div>

      <div className="py-16 md:py-20 lg:py-24 bg-gradient-to-b from-primary-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-block px-4 py-2 bg-primary-100 rounded-full mb-4">
              <span className="text-primary-700 font-semibold text-body-sm">Telehealth Services</span>
            </div>
            <h2 className="text-heading-xl md:text-display-sm text-neutral-900 mb-6">
              Quality Mental Healthcare, Accessible to Everyone
            </h2>
            <p className="text-body-lg text-neutral-600 max-w-3xl mx-auto leading-relaxed">
              At Blissful Days, we believe that everyone deserves access to high-quality
              behavioral healthcare. Our compassionate and dedicated team provides specialized
              services that address your unique needs and improve your quality of life. We work
              closely with each client to develop a personalized treatment plan tailored to their
              specific goals.
            </p>
          </div>
        </div>
      </div>

      <div className="py-16 md:py-20 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-heading-xl md:text-display-sm text-neutral-900 mb-4">
              Specialized Treatment Areas
            </h2>
            <p className="text-body-lg text-neutral-600">
              Expert psychiatric evaluation and medication management
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="bg-neutral-50 rounded-xl p-8 md:p-10">
                <h3 className="text-heading-md text-neutral-900 mb-6">
                  We Provide Treatment For:
                </h3>
                <div className="space-y-3">
                  {servicesList.map((service, index) => (
                    <div key={index} className="flex items-start gap-3 group">
                      <div className="flex-shrink-0 mt-1">
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          className="text-primary-500 text-lg group-hover:text-primary-600 transition-colors"
                        />
                      </div>
                      <span className="text-body-md text-neutral-700 group-hover:text-neutral-900 transition-colors">
                        {service}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <div className="relative rounded-xl overflow-hidden shadow-medium">
                <img
                  className="w-full h-[400px] md:h-[500px] object-cover"
                  src={adhd1}
                  alt="Mental health treatment"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-900/20 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="py-16 md:py-20 lg:py-24 bg-neutral-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-heading-xl md:text-display-sm text-neutral-900 mb-4">
              Explore Our Specialized Services
            </h2>
            <p className="text-body-lg text-neutral-600 max-w-2xl mx-auto">
              Click on any service below to learn more about our treatment approaches and how we can help you
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {CarouselItems.map((item, index) => (
              <div key={index} className="animate-scale-in" style={{ animationDelay: `${index * 100}ms` }}>
                <CarouselCard
                  src={item.src}
                  alt={item.alt}
                  title={item.title}
                  description={item.description}
                  link={item.link}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="py-16 md:py-20 lg:py-24 bg-gradient-to-br from-primary-500 to-primary-700">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-heading-xl md:text-display-sm text-white mb-6">
            Ready to Start Your Journey?
          </h2>
          <p className="text-body-lg text-white/90 mb-8 leading-relaxed">
            Take the first step towards better mental health. Our team is here to support you every step of the way.
          </p>
          <Link to="/contact">
            <button className="px-8 py-4 bg-white text-primary-600 font-semibold rounded-lg hover:bg-neutral-50 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
              Schedule a Consultation
            </button>
          </Link>
        </div>
      </div>

      <Partner />
      <Footer />
    </div>
  );
};

export default MainServicePage;
